export default {
  singular: 'Concours',
  actions: {
    create: 'Créer un concours',
    confirmDelete: 'Êtes-vous sûr de voulour supprimer ce concours ?',
    delete: 'Supprimer',
    cancel: 'Annuler'
  },
  empty: {
    title: 'Aucuns concours',
    message: 'Pour créer un concours, rien de plus simple, cliquer sur le lien suivant:'
  },
  state: {
    published: 'publié',
    testing: 'testé',
    terminated: 'terminé'
  },
  plural: 'Concours',
  section: {
    rounds: {
      title: 'Manches'
    },
    ranks: {
      title: 'Classement',
      button: {
        'load-more': 'Voir plus'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/contest.js